import Cookies from 'js-cookie';
import { NotificationManager } from 'react-notifications';
import { Request } from '../../classes/Request';

/**********************************************************FORGOT PASSWORD************************************************************************/

export const executeStage = async (
  form,
  partial = false,
  sequence,
  props,
  setFormTitle,
  setSequence,
  setStage,
  setPreviousUrl,
  setFlagError,
  setForm,
  setLastStep,
  setMode,
  setApplicant
) => {
  const { userId_02 } = Cookies.get();

  const request = new Request(
    `${process.env.REACT_APP_URL_API_LARAVEL}/execute_stage`,
    'post',
    null,
    {
      stage: props.history.location.state.params.stage || '',
      user_id: userId_02,
      partial,
      fields: form,
      sequence,
    }
  );

  const executeStageData = await request.executeRequest();

  if (executeStageData.code === 200) {
    const payload = executeStageData.data.data.data;

    if (payload.redirect_message) {
      await executeRedirect(
        payload.step,
        setFormTitle,
        setSequence,
        setStage,
        setPreviousUrl,
        setFlagError,
        setLastStep,
        setForm,
        setMode,
        setApplicant,
        payload.redirect_message
      );
      return;
    }

    setFormTitle(payload.form_name);
    setSequence(payload.sequence);
    setStage(payload.stage);
    setPreviousUrl(payload.previous_url);
    setFlagError(false);

    const executeStageJson = {
      form_name: payload.form_name,
      next_url: payload.next_url,
      previous_url: payload.previous_url,
      sequence: payload.sequence,
      stage_id: payload.stage,
      form: payload.form,
    };

    await processStage(
      executeStageJson,
      setLastStep,
      setFormTitle,
      setForm,
      setPreviousUrl,
      setMode,
      setApplicant
    );
  } else {
    setFlagError(true);
    setForm(executeStageData.form);
  }
};

/**********************************************************REDIRECT STAGE************************************************************************/
// Types offered by core's redirect action; any other value falls back to info.
const REDIRECT_NOTIFIERS = {
  success: 'success',
  warning: 'warning',
  danger: 'error',
};

const notifyRedirect = (redirect) => {
  if (!redirect || !redirect.message) return;

  const method = REDIRECT_NOTIFIERS[redirect.type] || 'info';
  NotificationManager[method](redirect.message);
};

export const executeRedirect = async (
  url,
  setFormTitle,
  setSequence,
  setStage,
  setPreviousUrl,
  setFlagError,
  setLastStep,
  setForm,
  setMode,
  setApplicant,
  redirect
) => {
  const request = new Request(url, 'get', null, {});
  const executeRedirectData = await request.executeRequest();

  // Request already shows its own error toast; keep the current form so the user can retry.
  if (!executeRedirectData || executeRedirectData.code !== 200) {
    setFlagError(true);
    return;
  }

  // process_stage has no root-level `stage`, only meta.stage_id
  const { meta, form, previous_url } = executeRedirectData.data.data.data;

  setFormTitle(meta.form_name);
  setSequence(parseInt(meta.current_step, 10));
  setStage(meta.stage_id);
  setPreviousUrl(previous_url);
  setApplicant(meta.applicant_id);
  setMode(meta.mode);
  setForm(form);
  setLastStep(false);
  setFlagError(false);

  notifyRedirect(redirect);
};

/******************************************************************PROCESS STAGE*******************************************************************/

export const processStage = async (
  form,
  setLastStep,
  setFormTitle,
  setForm,
  setPreviousUrl,
  setMode,
  setApplicant
) => {
  let processStageData = {};
  if (form.next_url) {
    const request = new Request(form.next_url, 'get', null, {});
    processStageData = await request.executeRequest();
  } else {
    setLastStep(true);
    setFormTitle('Etapa Finalizada');
    setForm(form.form);
  }
  if (processStageData.code === 200) {
    //MOSTRAR ALERTA EXITOSA CON EL MENSAJE QUE RETORNA LA API COMPONENTE
    setPreviousUrl(processStageData.data.data.data.previous_url);
    setApplicant(processStageData.data.data.data.meta.applicant_id);
    setMode(processStageData.data.data.data.meta.mode);
    setForm(processStageData.data.data.data.form);
  }
};

/**************************************************************************************************************************************************/
/******************************************************************PREVIOUS HANDLER*******************************************************************/

export const previousHandler = async (
  url,
  setFormTitle,
  setPreviousUrl,
  setForm,
  setSequence,
  setMode
) => {
  const request = new Request(url, 'get', null, {});
  const previousHandlerData = await request.executeRequest();

  if (previousHandlerData.code === 200) {
    setFormTitle(previousHandlerData.data.data.data.meta.form_name);
    setPreviousUrl(previousHandlerData.data.data.data.previous_url);
    setForm(previousHandlerData.data.data.data.form);
    setSequence(previousHandlerData.data.data.data.meta.current_step);
    setMode(previousHandlerData.data.data.data.meta.mode);
  }
};

/**************************************************************************************************************************************************/
/***********************************************************************************************************************************************/
